import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule } from '@trademe/tangram';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { BoatsAndMarineSummaryPageComponent } from './motors-summary-page.component';

@NgModule({
    imports: [CommonModule, TgGridModule],
    declarations: [BoatsAndMarineSummaryPageComponent],
    providers: [TmDateComponent],
    exports: [BoatsAndMarineSummaryPageComponent]
})
export class BoatsAndMarineSummaryPageModule {}
